import { Keyframes, keyframes } from '@emotion/react';
import theme from '@styles/theme';
import reusables from '@styles/theme/reusables';
type TAttribute = 'top' | 'center' | 'bottom';
const createAnimation = (from: TAttribute, to: TAttribute): Keyframes => {
  const positionAttributes: Record<TAttribute, Record<string, string | number>> = {
    top: {
      top: 0,
      transform: 'translateY(0)'
    },
    center: {
      top: '50%',
      transform: 'translateY(-50%)'
    },
    bottom: {
      top: '100%',
      transform: 'translateY(-100%)'
    }
  };
  return keyframes({
    '0%': positionAttributes[from],
    '100%': positionAttributes[to]
  });
};
export default {
  sliderGrid: {
    position: 'relative',
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: ['column', 'column', 'column', 'column', 'row-reverse'],
    flexWrap: 'nowrap',
    justifyContent: ['space-between', 'space-between', 'flex-start', 'flex-start', 'space-between'],
    padding: [0, 0, '80px 80px 80px 64px', '80px 80px 80px 64px', '10.740740741vh 10.15625vw']
  },
  descriptionVariantContainer: {
    padding: ['16px 64px 0 40px', '16px 64px 0 40px', '0'],
    position: ['relative', 'relative', 'absolute', 'absolute', 'relative'],
    height: ['calc(100vh - (100vw / 4) * 3 - 24px)', 'calc(100vh - (100vw / 4) * 3 - 24px)', 'auto'],
    width: ['auto', 'auto', 'auto', 'auto', '23.020833333vw'],
    top: ['unset', 'unset', '80px', '80px', 'unset'],
    bottom: ['unset', 'unset', 'unset', 'unset', 'unset'],
    left: ['unset', 'unset', '50%', '50%', 'unset'],
    transform: ['unset', 'unset', 'translateX(-50%)', 'translateX(-50%)', 'unset'],
    alignSelf: ['unset', 'unset', 'unset', 'unset', 'center'],
    flexGrow: [1, 1, 'unset'],
    display: ['flex', 'flex', 'block'],
    alignItems: ['center', 'center', 'unset'],
    ...reusables.mainTransition('all', 'cubic-bezier(.4,0,.2,1)', '.5s')
  },
  productDescriptionImageContainer: {
    position: 'relative',
    mb: ['16px', '16px', '40px'],
    overflow: 'hidden'
  },
  productDescriptionVariantText: (withBottomMargin: boolean) => ({
    letterSpacing: [`${theme.letterSpacings.normal} !important`, `${theme.letterSpacings.normal} !important`, `${theme.letterSpacings.normal} !important`, `${theme.letterSpacings.normal} !important`, `${theme.letterSpacings.caps} !important`],
    lineHeight: '140%',
    mt: ['8px', '8px', '10px'],
    mb: withBottomMargin ? '16px' : 0,
    fontSize: [`${theme.fontSizes.text}px !important`, `${theme.fontSizes.text}px !important`, `${theme.fontSizes.text}px !important`, `${theme.fontSizes.text}px !important`, `${theme.fontSizes.bigText}px !important`]
  }),
  descriptionVariantWrapper: (from: TAttribute, to: TAttribute) => ({
    position: 'relative',
    animation: ['none', 'none', 'none', 'none', `${createAnimation(from, to)} .45s both`],
    width: '100%',
    ...reusables.mainTransition('all', 'cubic-bezier(.4,0,.2,1)', '.5s')
  }),
  descriptionVariantDummyWrapper: {
    position: ['relative', 'relative', 'relative', 'relative', 'absolute'],
    top: 0,
    width: '100%',
    opacity: 0
  },
  descriptionVariantText: {
    letterSpacing: [`${theme.letterSpacings.normal} !important`, `${theme.letterSpacings.normal} !important`, `${theme.letterSpacings.normal} !important`, `${theme.letterSpacings.normal} !important`, `${theme.letterSpacings.caps} !important`],
    lineHeight: '140%',
    mt: '16px',
    mb: '24px',
    fontSize: [`${theme.fontSizes.text}px !important`, `${theme.fontSizes.text}px !important`, `${theme.fontSizes.text}px !important`, `${theme.fontSizes.text}px !important`, `${theme.fontSizes.bigText}px !important`]
  },
  mainImageContainer: {
    mt: ['16px', '16px', 0],
    width: ['auto', 'auto', '100%', '100%', '47.291666667vw'],
    position: ['relative', 'relative', 'absolute', 'absolute', 'relative'],
    top: ['unset', 'unset', 'unset', 'unset', 'unset'],
    bottom: ['unset', 'unset', '80px', '80px', 'unset'],
    left: ['unset', 'unset', '50%', '50%', 'unset'],
    transform: ['unset', 'unset', 'translateX(-50%)', 'translateX(-50%)', 'unset'],
    alignSelf: ['unset', 'unset', 'unset', 'unset', 'center'],
    ...reusables.mainTransition('all', 'cubic-bezier(.4,0,.2,1)', '.5s')
  },
  contentContainer: (height: number) => ({
    height: ['auto', 'auto', 'auto', 'auto', `${height}px`],
    width: '100%',
    margin: 'auto',
    overflow: 'hidden',
    ...reusables.mainTransition('all', 'cubic-bezier(.4,0,.2,1)', '.3s')
  })
};